import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UpsertSheetComponent } from './upsert-sheet.component';
import { TranslateModule } from '@ngx-translate/core';
import { QRCodeModule } from 'angularx-qrcode';

@NgModule({
  declarations: [UpsertSheetComponent],
  imports: [
    TranslateModule,
    FormsModule,
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    QRCodeModule
  ],
  exports: [UpsertSheetComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UpsertSheetModule { }
